import React from 'react'
import Tdata from '../data/Tdata'
function Package() {
  return (
    <div>
       <div className='dest1'>
    <div className='container py-5'>
    <div className='row justify-content-center'>
            <div className='col-lg-8'>
            <div className='popular py-5 text-center'>
          <p className='fs-6 fw-bold text-white-50 best'>POPULAR PACKAGES 2019</p>
          <h2 className='fs-1 fw-bold py-2'>Most Popular Adventure Packages</h2>
          <p className='fs-6 fw-normal'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi posuere tempor mauris, nec imperdiet mi rutrum eget. Donec quis ligula in tellus dictum consequat.</p>
          </div>
            </div>
        </div>
        <div className='row py-5'>
      {Tdata.map((a)=>(
        <div className='col-lg-3'>
        <div className='card'>
          <img className='w-100' src={a.image}/>
          <div className='card-body text-center know1'>
          <p className='text-secondary  ps-2'>{a.title}</p>
          <h5 className='fw-normal text-body py-3'>{a.description}</h5>
          <button type="button" class="btn mt-3 px-3 know ">Know More</button>
          
          </div>
        </div>
       </div>
      
      ))}
      </div>
    </div>
    </div>
    </div>
  )
}

export default Package
